import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { socialLoginPost } from "../network/login";
import { MY_URL } from "../client";

const KAKAO_CLIENT_ID = "d4cebc96b7c23e5722d74c39d984d9fb";
const KAKAO_REDIRECT_URI = MY_URL + '/auth'; // 본인의 실제 리다이렉트 URI

export function KakaoRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const code = new URL(window.location.href).searchParams.get("code");

    // code가 없으면 (에러 상황 등) 로그인 페이지로 돌려보내기
    if (!code) {
      alert("카카오 로그인에 실패했습니다.");
      navigate("/login");
      return;
    }

    // 1. 프론트에서 직접 카카오 토큰 발급받기
    const getKakaoToken = async () => {
      try {
        const response = await fetch("https://kauth.kakao.com/oauth/token", {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
          },
          body: new URLSearchParams({
            grant_type: "authorization_code",
            client_id: KAKAO_CLIENT_ID,
            redirect_uri: KAKAO_REDIRECT_URI,
            code: code,
          }),
        });

        if (!response.ok) throw new Error("카카오 토큰 발급 실패");

        const data = await response.json();
        const accessToken = data.access_token; // 이게 바로 idToken 역할

        //2. 백엔드에 카카오 access_token 전달 → 자체 JWT 발급받기
        const respon = await socialLoginPost("kakao", accessToken, "");
        console.log(respon)
        if(respon == 'INVALID_USERNAME')
        {
                  const queryParams = new URLSearchParams({
            id: 'kakao',
            socialAccountToken: accessToken
            //category: postCategory
          }).toString();

          // /detail 경로로 인자를 포함하여 GET 방식으로 이동
          navigate(`/signup?${queryParams}`);
      }else{

        navigate("/", { replace: true });
      }

        // 로그인 성공 → 원하는 페이지로 이동 (예: 메인페이지)
        //
      } catch (err) {
        console.error(err);
        alert("로그인 처리 중 오류가 발생했습니다.");
        navigate("/login", { replace: true });
      }
    };

    getKakaoToken();
  }, [navigate]);

  // 화면에는 아무것도 안 보여줘도 됨 (로딩 중 표시하고 싶으면 추가 가능)
  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      카카오 로그인 처리 중...
    </div>
  );
}

export default KakaoRedirect;